export function getAuthors(authors: string) {
	const authorsArray = authors?.split(",");
	const trimmedAuthorsArray = authorsArray?.map((author) => author.trim());
	const finalAuthors = trimmedAuthorsArray?.filter((author) => author !== "");

	return finalAuthors;
}
